import React from "react";
import ReactDOM from "react-dom/client";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { useTranslation } from "react-i18next";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createAppTheme } from "./theme";
import "./i18n";
import { registerAbosServiceWorker } from "./offline/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
const ltrCache = createCache({ key: "mui" });
const rtlCache = createCache({ key: "muirtl", stylisPlugins: [prefixer, rtlPlugin] });

function LocalizedTheme({ children }) {
  const { i18n } = useTranslation();
  const direction = i18n.resolvedLanguage === "ar" ? "rtl" : "ltr";
  const theme = React.useMemo(() => createAppTheme(direction), [direction]);
  return (
    <CacheProvider value={direction === "rtl" ? rtlCache : ltrCache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
}

root.render(
  <React.StrictMode>
    <LocalizedTheme>
      <App />
    </LocalizedTheme>
  </React.StrictMode>,
);

reportWebVitals();
registerAbosServiceWorker();
